"use strict";

var _slicedToArray = require("D:\\Event-Front-End\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("D:\\Event-Front-End\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("D:\\Event-Front-End\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(run),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(transformFile);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.run = run;

function _traverse() {
  var data = _interopRequireDefault(require("@babel/traverse"));

  _traverse = function _traverse() {
    return data;
  };

  return data;
}

var _pluginPass = _interopRequireDefault(require("./plugin-pass"));

var _blockHoistPlugin = _interopRequireDefault(require("./block-hoist-plugin"));

var _normalizeOpts = _interopRequireDefault(require("./normalize-opts"));

var _normalizeFile = _interopRequireDefault(require("./normalize-file"));

var _generate = _interopRequireDefault(require("./file/generate"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function run(config, code, ast) {
  var file, opts, _opts$filename, outputCode, outputMap, _ref, _opts$filename2;

  return _regeneratorRuntime.wrap(function run$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          return _context.delegateYield((0, _normalizeFile.default)(config.passes, (0, _normalizeOpts.default)(config), code, ast), "t0", 1);

        case 1:
          file = _context.t0;
          opts = file.opts;
          _context.prev = 3;
          return _context.delegateYield(transformFile(file, config.passes), "t1", 5);

        case 5:
          _context.next = 12;
          break;

        case 7:
          _context.prev = 7;
          _context.t2 = _context["catch"](3);
          _context.t2.message = "".concat((_opts$filename = opts.filename) != null ? _opts$filename : "unknown", ": ").concat(_context.t2.message);

          if (!_context.t2.code) {
            _context.t2.code = "BABEL_TRANSFORM_ERROR";
          }

          throw _context.t2;

        case 12:
          _context.prev = 12;

          if (opts.code !== false) {
            _ref = (0, _generate.default)(config.passes, file);
            outputCode = _ref.outputCode;
            outputMap = _ref.outputMap;
          }

          _context.next = 21;
          break;

        case 16:
          _context.prev = 16;
          _context.t3 = _context["catch"](12);
          _context.t3.message = "".concat((_opts$filename2 = opts.filename) != null ? _opts$filename2 : "unknown", ": ").concat(_context.t3.message);

          if (!_context.t3.code) {
            _context.t3.code = "BABEL_GENERATE_ERROR";
          }

          throw _context.t3;

        case 21:
          return _context.abrupt("return", {
            metadata: file.metadata,
            options: opts,
            ast: opts.ast === true ? file.ast : null,
            code: outputCode === undefined ? null : outputCode,
            map: outputMap === undefined ? null : outputMap,
            sourceType: file.ast.program.sourceType
          });

        case 22:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[3, 7], [12, 16]]);
}

function transformFile(file, pluginPasses) {
  var _iterator, _step, pluginPairs, passPairs, passes, visitors, _iterator2, _step2, _plugin2, _pass2, _i, _passPairs, _passPairs$_i, plugin, pass, fn, result, visitor, _i2, _passPairs2, _passPairs2$_i, _plugin, _pass, _fn, _result;

  return _regeneratorRuntime.wrap(function transformFile$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _iterator = _createForOfIteratorHelper(pluginPasses);
          _context2.prev = 1;

          _iterator.s();

        case 3:
          if ((_step = _iterator.n()).done) {
            _context2.next = 38;
            break;
          }

          pluginPairs = _step.value;
          passPairs = [];
          passes = [];
          visitors = [];
          _iterator2 = _createForOfIteratorHelper(pluginPairs.concat([(0, _blockHoistPlugin.default)()]));

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              _plugin2 = _step2.value;
              _pass2 = new _pluginPass.default(file, _plugin2.key, _plugin2.options);
              passPairs.push([_plugin2, _pass2]);
              passes.push(_pass2);
              visitors.push(_plugin2.visitor);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          _i = 0, _passPairs = passPairs;

        case 11:
          if (!(_i < _passPairs.length)) {
            _context2.next = 22;
            break;
          }

          _passPairs$_i = _slicedToArray(_passPairs[_i], 2), plugin = _passPairs$_i[0], pass = _passPairs$_i[1];
          fn = plugin.pre;

          if (!fn) {
            _context2.next = 19;
            break;
          }

          result = fn.call(pass, file);
          return _context2.delegateYield([], "t0", 17);

        case 17:
          if (!isThenable(result)) {
            _context2.next = 19;
            break;
          }

          throw new Error("You appear to be using an plugin with an async .pre, " + "which your current version of Babel does not support. " + "If you're using a published plugin, you may need to upgrade " + "your @babel/core version.");

        case 19:
          _i++;
          _context2.next = 11;
          break;

        case 22:
          visitor = _traverse().default.visitors.merge(visitors, passes, file.opts.wrapPluginVisitorMethod);
          (0, _traverse().default)(file.ast, visitor, file.scope);
          _i2 = 0, _passPairs2 = passPairs;

        case 25:
          if (!(_i2 < _passPairs2.length)) {
            _context2.next = 36;
            break;
          }

          _passPairs2$_i = _slicedToArray(_passPairs2[_i2], 2), _plugin = _passPairs2$_i[0], _pass = _passPairs2$_i[1];
          _fn = _plugin.post;

          if (!_fn) {
            _context2.next = 33;
            break;
          }

          _result = _fn.call(_pass, file);
          return _context2.delegateYield([], "t1", 31);

        case 31:
          if (!isThenable(_result)) {
            _context2.next = 33;
            break;
          }

          throw new Error("You appear to be using an plugin with an async .post, " + "which your current version of Babel does not support. " + "If you're using a published plugin, you may need to upgrade " + "your @babel/core version.");

        case 33:
          _i2++;
          _context2.next = 25;
          break;

        case 36:
          _context2.next = 3;
          break;

        case 38:
          _context2.next = 43;
          break;

        case 40:
          _context2.prev = 40;
          _context2.t2 = _context2["catch"](1);

          _iterator.e(_context2.t2);

        case 43:
          _context2.prev = 43;

          _iterator.f();

          return _context2.finish(43);

        case 46:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 40, 43, 46]]);
}

function isThenable(val) {
  return !!val && (typeof val === "object" || typeof val === "function") && !!val.then && typeof val.then === "function";
}